import { toTotalAmount } from "./decimal";

/**
 * Mirrors recomputeInvoiceTotalsFromLineItems in the backend's taxTotals.ts.
 *
.
 */
export interface DocumentTotals {
  totalExcludingTax: number;
  totalIncludingTax: number;
  totalTaxAmount: number;
  totalPayableAmount: number;
}

export interface DocumentTotalsInput {
  /** Sum of the line items' excluding-tax values, unrounded. */
  rawExcludingTax: number;
  totalTaxAmount: number;
  additionalDiscountAmount?: number | null;
  additionalFeeAmount?: number | null;
  roundingAmount?: number | null;
}

export const deriveDocumentTotals = ({
  rawExcludingTax,
  totalTaxAmount,
  additionalDiscountAmount,
  additionalFeeAmount,
  roundingAmount,
}: DocumentTotalsInput): DocumentTotals => {
  const totalExcludingTax = toTotalAmount(rawExcludingTax);
  const totalIncludingTax = toTotalAmount(totalExcludingTax + totalTaxAmount);

  const adjustedTotalPayable =
    totalIncludingTax -
    Number(additionalDiscountAmount || 0) +
    Number(additionalFeeAmount || 0) +
    Number(roundingAmount || 0);

  return {
    totalExcludingTax,
    totalIncludingTax,
    totalTaxAmount,
    totalPayableAmount:
      adjustedTotalPayable >= 0 ? toTotalAmount(adjustedTotalPayable) : 0,
  };
};
